import React from 'react';
import Post from '../Music';
import { MusicData } from '../interfaces';
import axios from '../const/axios';

export default class Music extends React.Component<{}, {
	posts: MusicData[]
}> {

	public state = {
		posts: [{
			title: 'Christ Church Music Society: Valentines\' Concert',
			subtitle: 'Liszt\'s Consolation No. 3 // Debussy\'s Clair de Lune from Suite Bergamasque',
			instrument: 'piano',
			date: '15th February, 2020',
			url: 'https://www.youtube.com/watch?v=KuUjcEnqDr4'
		}] as MusicData[]
	}

	async componentDidMount() {
		try {
			let { data } = await axios.get('/music.json?token=' + Math.random().toString(32).slice(2));
			this.setState({posts: data});
		} catch (e) {
			console.error(e);
		}
	}

	render() {
		return (
			<>
				{this.state.posts.map((p, i) => {
					return (
						<Post
							key={[p.title, p.subtitle, p.url, i].join('.')}
							{...p}
						/>
					)
				})}
			</>
		);
	}
}
